/**
 * Funkcje do szyfrowania haseł w frontend
 * Używamy SHA256 do szyfrowania przed wysłaniem do API
 */

import CryptoJS from 'crypto-js';

/**
 * Szyfruje hasło używając SHA256
 * @param {string} password - Hasło do zaszyfrowania
 * @returns {string} - Zaszyfrowane hasło
 */
export const hashPassword = (password) => {
  if (!password) return '';
  return CryptoJS.SHA256(password).toString();
};

/**
 * Sprawdza czy hasło jest już zahashowane (długość 64 znaki, tylko hex)
 * @param {string} password - Hasło do sprawdzenia
 * @returns {boolean} - True jeśli hasło jest zahashowane
 */
export const isHashedPassword = (password) => {
  if (!password) return false;
  return password.length === 64 && /^[a-f0-9]+$/i.test(password);
};

/**
 * Przygotowuje dane użytkownika do wysłania do API
 * Zawsze szyfruje hasło przed wysłaniem
 * @param {object} userData - Dane użytkownika
 * @returns {object} - Dane użytkownika z zaszyfrowanym hasłem
 */
export const prepareUserData = (userData) => {
  const preparedData = { ...userData };
  
  // Zawsze szyfruj hasło jeśli nie jest puste
  if (preparedData.haslo) {
    preparedData.haslo = hashPassword(preparedData.haslo);
  }
  
  return preparedData;
};
